import { Livewire, Alpine } from '../../../../../../../../vendor/livewire/livewire/dist/livewire.esm';
import Clipboard from '@ryangjchandler/alpine-clipboard'

Alpine.plugin(Clipboard)
Livewire.start()

// core version + navigation, pagination modules:
import {Swiper, Navigation, Pagination, Grid, Thumbs} from 'swiper';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/effect-fade';
import 'swiper/css/grid';
window.Swiper = Swiper

// Swal
import Swal from 'sweetalert2';
window.Swal = Swal;
window.Toast = Swal.mixin({
    toast: true,
    position: 'top-right',
    iconColor: 'white',
    customClass: {
        popup: 'colored-toast'
    },
    showConfirmButton: false,
    timer: 3330,
    timerProgressBar: true
});

// Lazyload
import lazySizes from 'lazysizes';

// fslightbox
import FsLightbox from "fslightbox";

const setupApp = ()=>
{
    lazySizes.init();
    refreshFsLightbox();

    let heroSwiper = new Swiper("#heroSwiper", {
        modules: [Navigation, Pagination],
        navigation: {
            nextEl: "#heroSwiperNext",
            prevEl: "#heroSwiperPrev",
        },
        pagination: {
            el: "#heroSwiperPagination",
            clickable: true,
        },
        loop: true,
    });

    let categoriesSwiper = new Swiper("#categoriesSwiper", {
        modules: [Navigation],
        slidesPerView: 3,
        spaceBetween: 5,
        centeredSlides: true,
        centeredSlidesBounds: true,
        breakpoints: {
            768: {
                slidesPerView: 5,
            },
            1280: {
                slidesPerView: 7,
            },
        },
        loop: true,
        navigation: {
            prevEl: ".categoriesSwiperNext",
            nextEl: ".categoriesSwiperPrev",
        },
    });

    let topProductSwiper = new Swiper("#topProductsSwiper", {
        modules: [Navigation],
        slidesPerView: 2,
        spaceBetween: 10,

        breakpoints: {
            640: {
                slidesPerView: 2,
            },
            768: {
                slidesPerView: 3,
            },
            1024: {
                slidesPerView: 4,
                spaceBetween: 20,
            },
            1280: {
                slidesPerView: 5,
                spaceBetween: 20,
            },
        },
        navigation: {
            prevEl: "#topProductsSwiperNext",
            nextEl: "#topProductsSwiperPrev",
        },
    });

    let brandSwiper = new Swiper("#brandsSwiper", {
        modules: [Navigation],
        slidesPerView: 4,
        spaceBetween: 5,
        centeredSlides: true,
        centeredSlidesBounds: true,
        breakpoints: {
            640: {
                slidesPerView: 5,
            },
            768: {
                centeredSlides: false,
                centeredSlidesBounds: false,
                slidesPerView: 4,
            },
            1024: {
                centeredSlides: false,
                centeredSlidesBounds: false,
                slidesPerView: 5,
                spaceBetween: 5,
            },
            1280: {
                centeredSlides: false,
                centeredSlidesBounds: false,
                slidesPerView: 6,
                spaceBetween: 5,
            },
        },
        loop: true,
        navigation: {
            prevEl: "#brandsSwiperNext",
            nextEl: "#brandsSwiperPrev",
        },
    });

    var specialSwiper = new Swiper("#specialSwiper", {
        modules: [ Grid ],
        slidesPerView: 1.2,
        spaceBetween: 20,
        grid: {
            rows: 2,
            fill: 'row'
        },
        breakpoints: {
            480:{
                slidesPerView: 1.6,
                spaceBetween: 16,
            },
            768: {
                slidesPerView: 2.2,
                spaceBetween: 16,
            },
            1024: {
                slidesPerView: 3,
                spaceBetween: 16,
                enabled: false,
            },
        },
    });

    let imageSwiper = new Swiper("#aboutSwiper", {
        modules: [Navigation],
        loop: true,
        navigation: {
            prevEl: "#aboutSwiperNext",
            nextEl: "#aboutSwiperPrev",
        },
    });

    let blogSwiper = new Swiper("#blogSwiper", {
        modules: [Navigation],
        slidesPerView: 1.5,
        spaceBetween: 10,

        breakpoints: {
            640: {
                slidesPerView: 2,
            },
            768: {
                slidesPerView: 3,
            },
            1024: {
                slidesPerView: 3.5,
                spaceBetween: 20,
            },
            1280: {
                slidesPerView: 4,
                spaceBetween: 20,
            },
        },

        navigation: {
            prevEl: "#blogSwiperNext",
            nextEl: "#blogSwiperPrev",
        },
    });

    let productGalleryThumb = new Swiper('.product-thumb-imgs-swiper-container', {
        modules: [Navigation],
        direction: 'horizontal',
        spaceBetween: 10,
        slidesPerView: 3,
        breakpoints: {
            768:{
                slidesPerView: 4,
            },
        },
        freeMode: true,
        watchSlidesVisibility: true,
        watchSlidesProgress: true,
    });

    let productGallery = new Swiper('.product-imgs-swiper-container', {
        modules: [Navigation, Thumbs],
        direction: 'horizontal',
        centeredSlides:true,
        centeredSlidesBounds:true,
        slidesPerView:1,
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        spaceBetween: 10,
        thumbs: {
            swiper : productGalleryThumb
        },
    });

    let productRelatedItems = new Swiper('.product-related-items',  {
        slidesPerView: 1.2,
        spaceBetween: 15,
        breakpoints:{
            768:{
                slidesPerView: 2.3,
            },
            1024: {
                slidesPerView:3.3,
            },
            1280:{
                slidesPerView:4.3,
            },
        }
    });
}

["livewire:initialized", "livewire:navigated", "resize", "pageChanged"].forEach((event) => {
    window.addEventListener(event, setupApp)
})




